import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    height: 160,
    hemheight: 0,
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
